import React, { Component } from "react";
import { Box, Flex, Menu, Spacer, MenuButton, MenuItem, MenuList, MenuDivider, Button, Image, Text, Tag, TagLeftIcon, TagLabel, HStack, Tooltip } from '@chakra-ui/react';
import GlassbitLogo from "../../../assets/images/logos/glasschain-logo.png";

import "../../../assets/css/navbar.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapPin, faBars, faSatelliteDish, faWifi, faPlane, faGear, faBinoculars, faHeartbeat, faHeartBroken, faPaperPlane } from "@fortawesome/free-solid-svg-icons";

import ConfigService from "../../../services/ConfigService";
import CoreService from "../../../services/CoreService";

import RoleManager from "../../../models/RoleManager";
import { AppSecurityKey } from "../../../models/AppSecurityKey";
import "../../../assets/css/timer.css";
import ExpirationTimer from "./ExpirationTimer";

import { HealthStatusType } from "../../../models/HealthStatusType";


function Animate({ children, on }) {
    return (on === undefined)
        ? <div>{children}</div>
        : <div className="satelliteanim" key={on}>{children}</div>
}


export default class Navbar extends Component {
    constructor(props) {
        super(props);
        this.configService = new ConfigService();
        this.coreService = new CoreService();
        this.state = {
            isDrawerOpen: false,
            customerLogoImgSrc: "",
            healthColor: "lightgreen",

        }
        this.toggleDrawer = this.toggleDrawer.bind(this);
    }

    async componentDidMount() {
        let customerLogoImgSrc = this.configService.getCustomerLogoImagePath(this.props.userSession.gcid);
        this.setState({
            customerLogoImgSrc: customerLogoImgSrc
        });
    }

    async componentDidUpdate(prevProps)
    {
        if (prevProps.healthInfoTriggerKey != this.props.healthInfoTriggerKey)
        {
            var overallHealth = (this.props.healthInfo) ? this.props.healthInfo.overallStatus() : HealthStatusType.UNKNOWN;
            var healthColor = (overallHealth == HealthStatusType.OK) ? "lightgreen" :
                (overallHealth == HealthStatusType.WARNING) ? "yellow" : "red";
            this.setState({healthColor: healthColor});
        }
        if (prevProps.onlineStatusChangeKey != this.props.onlineStatusChangeKey)
        {
            // used to inform system of change that may not be caught because props.onlineInfo is not a primitive
        }
    }


    toggleDrawer() {
        this.setState({
            isDrawerOpen: !this.state.isDrawerOpen
        })
    }





    render() {

        var gcidLogo = this.configService.getCustomerLogoImagePath(this.props.userSession.gcid);
   
        return (
            <div className={(this.props.isVisible) ? "navbar" : "navbar-hidden"}>

                <Flex w='100vw' justify={'space-between'} alignItems='center' maxH='10vh'>
                    <Image
                        src={GlassbitLogo}
                        alt="Customer Logo"

                        fit='scale-down'
                        marginLeft={'20px'}
                        boxSize='4vw'
                    />
                    <Text
                        fontSize={{ base: '10px', md: '16px', lg: '24px' }}
                        marginTop='3vh'
                    >
                        Glasschain Item Tracer Automation
                    </Text>

                    <Spacer />
                    <Box className="image-container">
                    <Image src={gcidLogo}
                        alt="Customer Logo"
                        objectFit='scale-down'
                        boxSize='10vw'
                    />
                    </Box>
                    <Spacer />
                    <HStack alignItems='baseline'>
                        <Box p='2'>
                            <ExpirationTimer
                                expires={this.props.sessionExpiration}
                                alertSecondsLeft={this.props.alertSecondsLeft}
                                expireSecondsLeft={this.props.expireSecondsLeft}
                                onExpiredToken={this.props.onExpiredToken}
                                onlineInfo={this.props.onlineInfo}
                            />
                            {/*
                            <Tag id='offlineCounter' onClick={(e) => this.props.onPurgeOfflineObservationsRequest(this.props.inQueueCount)}>
                                <FontAwesomeIcon icon={faPaperPlane} style={{ marginRight: "5px", color: (this.props.inQueueCount > 0) ? 'green' : 'grey' }} />
                                <TagLabel style={{ color: (this.props.inQueueCount > 0) ? 'green': 'lightgrey' }}>{this.props.inQueueCount}</TagLabel>
                            </Tag>
                            */}
                        </Box>
                        <Box p='2'>
                            <Flex direction='column'>
                                <Text style={{ margin: "0" }}>{this.props.userSession.uid}</Text>
                                <HStack>
                                        <FontAwesomeIcon icon={faWifi} color={(this.props.onlineInfo.isOnline) ? "lightgreen": "grey"} />&nbsp;
                                        <FontAwesomeIcon icon={faHeartbeat} color={this.state.healthColor} />
                                    <Animate on={this.props.lotWatcherRunning}>
                                            <FontAwesomeIcon icon={faSatelliteDish} color={(this.props.lotWatcherRunning) ? "green" : (this.props.autoRefresh) ? "lightgreen" : "red"} />
                                    </Animate>

                                </HStack>                          
                            </Flex>
                        </Box>
                    </HStack>
                    <Box p='3'>
                        <Menu>
                            <MenuButton as={Button} >
                                <FontAwesomeIcon icon={faBars} color="white" />
                            </MenuButton>
                            <MenuList>
                                <MenuItem color="black" isDisabled={(!RoleManager.hasRoleRights(AppSecurityKey.VIEW_DASHBOARD, this.props.userSession.token)) || (!this.props.onlineInfo.isConnected)} onClick={(e) => this.props.onDashboardPageRequest()}>Dashboard</MenuItem>
                                <MenuItem color="black" isDisabled={(!RoleManager.hasRoleRights(AppSecurityKey.VIEW_ORGCONFIG, this.props.userSession.token)) || (!this.props.onlineInfo.isConnected)} onClick={(e) => this.props.onOrgConfigManagementPageRequest()}>Org Config Viewer</MenuItem>
                                <MenuItem color="black" isDisabled={(!RoleManager.hasRoleRights(AppSecurityKey.EDIT_USERS, this.props.userSession.token)) || (!this.props.onlineInfo.isConnected)} onClick={(e) => this.props.onUserManagementPageRequest()}>User Management</MenuItem>
                                <MenuItem color="black" isDisabled={!RoleManager.hasRoleRights(AppSecurityKey.EXPERIMENTAL_ACCESS, this.props.userSession.token)} onClick={(e) => this.props.onSubscriberManagementPageRequest()}>Event Subscriber Management</MenuItem>
                                <MenuItem color="black" isDisabled={!RoleManager.hasRoleRights(AppSecurityKey.EXPERIMENTAL_ACCESS, this.props.userSession.token)} onClick={(e) => this.props.onTelemetryPageRequest()}>Telemetry</MenuItem>
                                <MenuDivider />
                                <MenuItem color="black" isDisabled={(!this.props.onlineInfo.isConnected)} onClick={(e) => this.props.onLogoutRequest()}>Log Out</MenuItem>
                                <MenuItem color="black" onClick={(e) => this.props.onUserGuideRequest()}>User Guide</MenuItem>
                                <MenuItem color="black" onClick={(e) => this.props.onAboutOpen(e)}>About</MenuItem>
                                <MenuItem color="black" onClick={(e) => this.props.onChangeHistoryPageRequest(e)}>Change History</MenuItem>



                            </MenuList>
                        </Menu>
                    </Box>
                </Flex>
            </div>
        )
    }
}